// Domínio raiz partilhado pelos três subdomínios da app (www, cond,
// prop) — a sessão (cookie httpOnly `Domain=.<dominio-raiz>`) e os
// redireccionamentos entre subdomínios dependem deste valor coincidir com o
// que o backend usa para emitir o cookie (ver app.dominio-raiz no backend).
const FALLBACK_DOMINIO_RAIZ = 'indlus.com'
const dominioRaizConfigurado = String(import.meta.env.VITE_DOMINIO_RAIZ ?? '').trim().toLowerCase()
const dominioRaizValido = dominioRaizConfigurado === 'localhost'
    || /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/.test(dominioRaizConfigurado)

// Variáveis ausentes no Azure Pipelines podem chegar ao bundle como texto
// literal (por exemplo, `${vite_dominio_raiz}`). Nunca use esse placeholder
// como hostname; em produção, recorra ao domínio oficial.
export const DOMINIO_RAIZ = dominioRaizValido ? dominioRaizConfigurado : FALLBACK_DOMINIO_RAIZ

// Em desenvolvimento local (VITE_DOMINIO_RAIZ=localhost, a par do
// app.dominio-raiz=localhost do backend) não há separação real de
// subdomínios — só um servidor Vite a servir tudo. Construir um host tipo
// "cond.localhost" exigiria DNS/allowedHosts extra e não corresponde
// a nada a correr, por isso aqui mantemo-nos no mesmo host:porta actual, só
// mudando a rota.
const isLocalDev = DOMINIO_RAIZ === 'localhost'

/** Constrói o URL absoluto de um subdomínio para navegação de browser real (`window.location.href`). */
export function buildSubdomainUrl(subdominio: 'www' | 'cond' | 'prop', path: string): string {
    if (isLocalDev) {
        return `${window.location.protocol}//${window.location.host}${path}`
    }
    return `https://${subdominio}.${DOMINIO_RAIZ}${path}`
}

const PLATFORM_ADMIN_FLAG = 'platform-admin'

/**
 * `true` quando a app está a servir o painel de administração da plataforma
 * (`admin.<dominio-raiz>`). Nesse caso o `main.tsx` monta uma árvore separada
 * (login + listagem de tenants) e nenhuma das rotas da app normal.
 *
 * Em produção decide-se pelo hostname. Em dev local não há subdomínios reais,
 * por isso activa-se com `?admin=1` no URL — persistido em `sessionStorage`
 * para sobreviver à navegação dentro do painel (limpar: `?admin=0`).
 */
export function isPlatformAdminHost(): boolean {
    const host = window.location.hostname.toLowerCase()
    if (host === `admin.${DOMINIO_RAIZ}` || host.startsWith('admin.')) return true

    if (!isLocalDev) return false

    const param = new URLSearchParams(window.location.search).get('admin')
    try {
        if (param === '1') sessionStorage.setItem(PLATFORM_ADMIN_FLAG, '1')
        if (param === '0') sessionStorage.removeItem(PLATFORM_ADMIN_FLAG)
        return sessionStorage.getItem(PLATFORM_ADMIN_FLAG) === '1'
    } catch {
        return param === '1'
    }
}
